import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import IssuesColumn from '../components/IssuesColumn'
import { LoadingSpinner } from '../../common'

const InProgressContainer = ({
  loading,
  loaded,
  numResults,
  docs,
}) => {
  return (
    <>
      {loading && <LoadingSpinner />}
      {loaded && <IssuesColumn title="In progress" numResults={numResults} docs={docs} />}
    </>
  )
}

InProgressContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
  numResults: PropTypes.number.isRequired,
  docs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

const mapStateToProps = ({
  issues: { inProgress: { loading, loaded, data: { numResults, docs } } },
}) => ({
  loading,
  loaded,
  numResults,
  docs,
})

export default connect(mapStateToProps)(InProgressContainer)
